import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
import { _getParamsFromLibMaterijalLimParams } from './ter-materijal-utils';
import { terUtilsNumberRoundUp, terUtils_get_naziv_materijala_by_ident } from './ter-utils';
import { protobomp_manipulator } from '../utils/frfr-protobomp-utils';
import { terProtobompUtils_make_protobomp_manifest_terkk_latest, terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL } from './ter-protobomp-utils';
import { js_utils } from '../utils/frfr-js-utils';
import { MINUS, SPACE } from '../utils/frfr-string-consts';
import { ROUND, XIF } from '../utils/excel-functions-utils';


export const derDraftel_terkk_kucisteelektrogrejaca_pripremi_pods_input_inherited_za_draftel = (virtel_k, virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    // ...draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.default_preset_state(),
    tipkomore: virtel_k.tipkomore,
    msirinaunutrasnjaizmedjupregradnih: virtel_m.msirinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjukrilaca: virtel_m.mvisinaunutrasnjaizmedjukrilaca,
  };
  return pods_input_inherited;
};


//
export const _derivat_terkk_kucisteelektrogrejaca_izracunaj_materijale = (pods_input, cparams_combined) => {
  //
  const tipkomore = pods_input.tipkomore;
  //
  let _cpci = {};
  if (cparams_combined && cparams_combined.terkk_materijal_ident && js_utils.is_object(cparams_combined.terkk_materijal_ident)) { // validate cparams TODO
    // By cparmas
    _cpci = cparams_combined.terkk_materijal_ident;
  }
  //
  let tipmetalalima = "pocinkovani";
  if (tipkomore === "HYGIENE:pro") {
    tipmetalalima = "prohrom";
  } else {
    tipmetalalima = "pocinkovani";
  }
  //
  let kelg_materijal_lim = null;
  if (tipmetalalima === "pocinkovani") {
    kelg_materijal_lim = _cpci.kelg_materijal_lim_pocinkovani;
  }
  if (tipmetalalima === "prohrom") {
    kelg_materijal_lim = _cpci.kelg_materijal_lim_prohrom;
  }
  //
  return {
    tipmetalalima,
    kelg_materijal_lim,
  };
};


//
export const _derivat_terkk_kucisteelektrogrejaca_pbnode_dirty_enrich = (pbnode_state_ref, protobomp_superdata, is_init) => {
  // DIRTY ENRICH
  // TODO ...props super superProps
  // console.log('item_ref, protobomp_superdata', item_ref, protobomp_superdata);
  const item = pbnode_state_ref;
  const family = item.pbnode_family;
  let povrsina = -1;
  let _cnc = null;
  let _naziv = null;
  let _materijal = '?'; // item.identmaterijala
  let _naziv_profil_komore_50_ili_70 = '?';
  let _naziv_tip_kadice = '?';
  let _tip_klizaca_abc = '?';
  let _tip_kadice = '?';
  let _strana_maske = '?';
  let _sufix = '?';
  let _visina_20_ili_35 = -1;
  /*
  Gde su: 

  */
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(item.identmaterijala);
  if (is_init === true) {
    if (typeof _mat_params.naziv === 'string') {
      item.naziv_materijala = _mat_params.naziv; // DIRTY
    } else {
      item.naziv_materijala = ''; // DIRTY
    }
  }
  const _tipmetalalima = _mat_params?.naziv_materijala;
  if (_tipmetalalima === "Prohrom") {
    _materijal = "SS";
  }
  if (_tipmetalalima === "Pocinkovani") {
    _materijal = "GS";
  }
  //
  const {
    msirinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjukrilaca,
    kelg_kolikoredova,
    kelg_kolikogrejacapovisini,
    kelg_sirinakucista,
    kelg_rak_termostat,
    kelg_kolicina_p5,
  } = protobomp_superdata;
  //

  //
  if (true) {
    // sklop
    if (family === 'terkk$kelg/SKLOP_KELG') { // 1.
      /*
      Naziv: "KUCISTE ELEKTRO GREJACA "$msirinaunutrasnjaizmedjupregradnih"X"$mvisinaunutrasnjaizmedjukrilaca" "$Broj_redova"R " $Broj_grejaca_po_visini "G"
      Broj komada: $kolicina
      Jedinica mere: Kom
      Operacija1: Sklapanje
      Radni centar 1: Finalizacija
      */
      item.distinction_key = "terkk$kelg/SKLOP_KELG"; // DIRTY
      item.tip = "A"; // DIRTY
      _naziv = "KUCISTE ELEKTRO GREJACA  " + msirinaunutrasnjaizmedjupregradnih + "x" + mvisinaunutrasnjaizmedjukrilaca + SPACE + kelg_kolikoredova + "R " + kelg_kolikogrejacapovisini + "G"; //
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSKL"; // DIRTY
      item.rc1 = "GRCFIN"; // DIRTY
      //
      item.duzina = msirinaunutrasnjaizmedjupregradnih; // DIRTY
      item.visina = mvisinaunutrasnjaizmedjukrilaca; // DIRTY
      item.sirina = kelg_sirinakucista; // DIRTY
      item.kelg_rak_termostat = kelg_rak_termostat; // DIRTY
      item.kelg_kolikoredova = kelg_kolikoredova; // DIRTY // TODO ???
      item.kelg_kolikogrejacapovisini = kelg_kolikogrejacapovisini; // DIRTY
    }
    //
    //
    if (family === 'terkk$kelg/P1') { // 2. P1
      /*
      Naziv: KUCISTE ELEKTRO GREJACA-P1"
      Broj komada:1
      Dim1: $sirina_kucista
      Dim2: $mvisinaunutrasnjaizmedjukrilaca
      Površina: Razvijena1*Razvijena2/1000000
      Razvijena1: $sirina_kucista+195,19
      Razvijena2: $mvisinaunutrasnjaizmedjukrilaca
      CNC crtez: "P01-22-A-"$msirinaunutrasnjaizmedjupregradnih"-"$mvisinaunutrasnjaizmedjukrilaca"-R"$Broj_redova"XG"$Broj_grejaca_po_visini"-P1"
      Operacija 1: Sečenje
      Radni centar 1: Amada
      Operacija 2: Savijanje
      Radni centar 2: Ermaksan
      */
      item.distinction_key = "terkk$kelg/A_P1"; // DIRTY
      item.tip = "A-P1"; // DIRTY
      _naziv = "KUCISTE ELEKTRO GREJACA-P1"; //
      item.kolicina = 1; // DIRTY
      item.dimenzija1 = kelg_sirinakucista; // DIRTY
      item.dimenzija2 = mvisinaunutrasnjaizmedjukrilaca; // DIRTY
      item.razvijenamera1 = kelg_sirinakucista + 195.19; // DIRTY
      item.razvijenamera2 = mvisinaunutrasnjaizmedjukrilaca; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      // item.identmaterijala = pkz_materijal_lim; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-22-A-" + msirinaunutrasnjaizmedjupregradnih + MINUS + mvisinaunutrasnjaizmedjukrilaca + "-R" + kelg_kolikoredova + "XG" + kelg_kolikogrejacapovisini + "-P1";
      //
      item.kelg_rak_termostat = kelg_rak_termostat; // DIRTY
      item.kelg_kolikoredova = kelg_kolikoredova; // DIRTY // TODO ???
      item.kelg_kolikogrejacapovisini = kelg_kolikogrejacapovisini; // DIRTY
    }
    //
    if (family === 'terkk$kelg/P2') { // 3. P2
      /*
      Naziv: KUCISTE ELEKTRO GREJACA-P2"
      Broj komada:1
      Dim1: $sirina_kucista
      Dim2: $mvisinaunutrasnjaizmedjukrilaca
      Površina: Razvijena1*Razvijena2/1000000
      Razvijena1: $sirina_kucista+90,19
      Razvijena2: $mvisinaunutrasnjaizmedjukrilaca
      CNC crtez: "P01-22-A-"$msirinaunutrasnjaizmedjupregradnih"-"$mvisinaunutrasnjaizmedjukrilaca"-R"$Broj_redova"XG"$Broj_grejaca_po_visini"-P2"
      Operacija 1: Sečenje
      Radni centar 1: Amada
      Operacija 2: Savijanje
      Radni centar 2: Ermaksan
      */
      item.distinction_key = "terkk$kelg/A_P2"; // DIRTY
      item.tip = "A-P2"; // DIRTY
      _naziv = "KUCISTE ELEKTRO GREJACA-P2"; //
      item.kolicina = 1; // DIRTY
      item.dimenzija1 = kelg_sirinakucista; // DIRTY
      item.dimenzija2 = mvisinaunutrasnjaizmedjukrilaca; // DIRTY
      item.razvijenamera1 = kelg_sirinakucista + 90.19; // DIRTY
      item.razvijenamera2 = mvisinaunutrasnjaizmedjukrilaca; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      // item.identmaterijala = pkz_materijal_lim; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-22-A-" + msirinaunutrasnjaizmedjupregradnih + MINUS + mvisinaunutrasnjaizmedjukrilaca + "-R" + kelg_kolikoredova + "XG" + kelg_kolikogrejacapovisini + "-P2";
      //
      item.kelg_rak_termostat = kelg_rak_termostat; // DIRTY
      item.kelg_kolikoredova = kelg_kolikoredova; // DIRTY // TODO ???
      item.kelg_kolikogrejacapovisini = kelg_kolikogrejacapovisini; // DIRTY
    }
    //
    if (family === 'terkk$kelg/P3') { // 4. P3
      /*
      Naziv: KUCISTE ELEKTRO GREJACA-P3"
      Broj komada:1
      Dim1: $sirina_kucista
      Dim2: $msirinaunutrasnjaizmedjupregradnih-84,9
      Površina: Razvijena1*Razvijena2/1000000
      Razvijena1: $sirina_kucista+90,19
      Razvijena2: $msirinaunutrasnjaizmedjupregradnih-84,9
      CNC crtez: "P01-22-A-"$msirinaunutrasnjaizmedjupregradnih"-"$mvisinaunutrasnjaizmedjukrilaca"-R"$Broj_redova"XG"$Broj_grejaca_po_visini"-P3"
      Operacija 1: Sečenje
      Radni centar 1: Amada
      Operacija 2: Savijanje
      Radni centar 2: Ermaksan
      */
      item.distinction_key = "terkk$kelg/A_P3"; // DIRTY
      item.tip = "A-P3"; // DIRTY
      _naziv = "KUCISTE ELEKTRO GREJACA-P3"; //
      item.kolicina = 1; // DIRTY
      item.dimenzija1 = kelg_sirinakucista; // DIRTY
      item.dimenzija2 = msirinaunutrasnjaizmedjupregradnih - 84.9; // DIRTY
      item.razvijenamera1 = kelg_sirinakucista + 90.19; // DIRTY
      item.razvijenamera2 = msirinaunutrasnjaizmedjupregradnih - 84.9; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      // item.identmaterijala = pkz_materijal_lim; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-22-A-" + msirinaunutrasnjaizmedjupregradnih + MINUS + mvisinaunutrasnjaizmedjukrilaca + "-R" + kelg_kolikoredova + "XG" + kelg_kolikogrejacapovisini + "-P3";
      //
      item.kelg_rak_termostat = kelg_rak_termostat; // DIRTY
      item.kelg_kolikoredova = kelg_kolikoredova; // DIRTY // TODO ???
      item.kelg_kolikogrejacapovisini = kelg_kolikogrejacapovisini; // DIRTY
    }
    //
    if (family === 'terkk$kelg/P4') { // 5. P4
      /*
      Naziv: KUCISTE ELEKTRO GREJACA-P4"
      Broj komada:1
      Dim1: $sirina_kucista
      Dim2: $msirinaunutrasnjaizmedjupregradnih-84,9
      Površina: Razvijena1*Razvijena2/1000000
      Razvijena1: $sirina_kucista+90,19
      Razvijena2: $msirinaunutrasnjaizmedjupregradnih-84,9
      CNC crtez: "P01-22-A-"$msirinaunutrasnjaizmedjupregradnih"-"$mvisinaunutrasnjaizmedjukrilaca"-R"$Broj_redova"XG"$Broj_grejaca_po_visini"-P4"
      Operacija 1: Sečenje
      Radni centar 1: Amada
      Operacija 2: Savijanje
      Radni centar 2: Ermaksan
      */
      item.distinction_key = "terkk$kelg/A_P4"; // DIRTY
      item.tip = "A-P4"; // DIRTY
      _naziv = "KUCISTE ELEKTRO GREJACA-P4"; //
      item.kolicina = 1; // DIRTY
      item.dimenzija1 = kelg_sirinakucista; // DIRTY
      item.dimenzija2 = msirinaunutrasnjaizmedjupregradnih - 84.9; // DIRTY
      item.razvijenamera1 = kelg_sirinakucista + 90.19; // DIRTY
      item.razvijenamera2 = msirinaunutrasnjaizmedjupregradnih - 84.9; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      // item.identmaterijala = pkz_materijal_lim; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-22-A-" + msirinaunutrasnjaizmedjupregradnih + MINUS + mvisinaunutrasnjaizmedjukrilaca + "-R" + kelg_kolikoredova + "XG" + kelg_kolikogrejacapovisini + "-P4";
      //
      item.kelg_rak_termostat = kelg_rak_termostat; // DIRTY
      item.kelg_kolikoredova = kelg_kolikoredova; // DIRTY // TODO ???
      item.kelg_kolikogrejacapovisini = kelg_kolikogrejacapovisini; // DIRTY
    }
    //
    if (family === 'terkk$kelg/P5') { // 6. P5
      /*
      Naziv: KUCISTE ELEKTRO GREJACA-P5"
      Broj komada:
      IF $Broj_redova>2 THEN ROUND((($msirinaunutrasnjaizmedjupregradnih-270)/600)+1;0)2
      ELSE
      ROUND((($msirinaunutrasnjaizmedjupregradnih-270)/600)+1;0)
      Dim1: 42
      Dim2: $mvisinaunutrasnjaizmedjukrilaca-70
      Površina: Razvijena1Razvijena2/1000000
      Razvijena1: 73,10
      Razvijena2: $mvisinaunutrasnjaizmedjukrilaca-38,9
      CNC crtez: "P01-22-A-"$msirinaunutrasnjaizmedjupregradnih"-"$mvisinaunutrasnjaizmedjukrilaca"-R"$Broj_redova"XG"$Broj_grejaca_po_visini"-P5"
      Operacija 1: Sečenje
      Radni centar 1: Amada
      Operacija 2: Savijanje
      Radni centar 2: Ermaksan
      */
      item.distinction_key = "terkk$kelg/A_P5"; // DIRTY
      item.tip = "A-P5"; // DIRTY
      _naziv = "KUCISTE ELEKTRO GREJACA-P5"; //
      item.kolicina = kelg_kolicina_p5; // DIRTY
      item.dimenzija1 = 42; // DIRTY
      item.dimenzija2 = mvisinaunutrasnjaizmedjukrilaca - 70; // DIRTY
      item.razvijenamera1 = 73.10; // DIRTY
      item.razvijenamera2 = mvisinaunutrasnjaizmedjukrilaca - 38.9; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      // item.identmaterijala = pkz_materijal_lim; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-22-A-" + msirinaunutrasnjaizmedjupregradnih + MINUS + mvisinaunutrasnjaizmedjukrilaca + "-R" + kelg_kolikoredova + "XG" + kelg_kolikogrejacapovisini + "-P5";
      //
      item.kelg_rak_termostat = kelg_rak_termostat; // DIRTY
      item.kelg_kolikoredova = kelg_kolikoredova; // DIRTY // TODO ???
      item.kelg_kolikogrejacapovisini = kelg_kolikogrejacapovisini; // DIRTY
      item.visina = item.dimenzija1; // DIRTY // Parametar Par2 je fiksni za deo P5 i uvek iznosi 45mm. Ovo 45mm možeš da promeniš u 42mm, greškom sam stavio 45mm
      item.kelg_sirinakucista = kelg_sirinakucista; // DIRTY
    }
    //
    if (family === 'terkk$kelg/PRITEZAC') { // 7. ovaj element se unosi kao materijal
      /*
      ovaj element se unosi kao materijal:
      ident: ELGP6000000
      Naziv: "Pritezač elektro grejača"
      Količina: ($Broj_redova*$Broj_grejaca_po_visini)*količina elementa P5
      */
      item.kolicina = (kelg_kolikoredova * kelg_kolikogrejacapovisini) * kelg_kolicina_p5; // DIRTY
    }
    //
    //
  }
  // 
  if (povrsina > -1) {
    item.povrsina = terUtilsNumberRoundUp((povrsina / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale // DIRTY
  }
  if (_cnc) {
    item.cnccrtez = _cnc; // DIRTY
  }
  if (_naziv) {
    item.naziv = _naziv; // DIRTY
  }
  //
  return item;
};


//
export const _derivat_terkk_kelg_izracunaj_za_step_protobomp = (state, pods_input) => {
  console.log('_derivat_terkk_kelg_izracunaj_za_step_protobomp state', state);
  //
  const {
    msirinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjukrilaca,
  } = pods_input;
  const {
    kelg_materijal_lim,
    kelg_kolikoredova,
    kelg_kolikogrejacapovisini,
    kelg_sirinakucista,
    kelg_rak_termostat,
    kolicina,
  } = state;
  //

  let kelg_kolicina_p5;
  /*
  if (kelg_kolikoredova > 2) {
    kelg_kolicina_p5 = ROUND(((msirinaunutrasnjaizmedjupregradnih - 270) / 600) + 1, 0) * 2; //
  } else {
    kelg_kolicina_p5 = ROUND(((msirinaunutrasnjaizmedjupregradnih - 270) / 600) + 1, 0); //
  }
  */
  /*
  NJ 2025-01-09: Potrebno je formulu za proračun broja ojačanja (element p5) izmeniti sa formulom iz excella:
  =(IF(kelg_kolikoredova<=3; 1; 0) + IF(kelg_kolikoredova>=4; 1; 0) + IF(kelg_kolikoredova>=5; 1; 0) + IF(kelg_kolikoredova>=6; 1; 0))*(ROUND(((msirinaunutrasnjaizmedjupregradnih-270)/600)+1;0))
  */
  //  = (XIF(kelg_kolikoredova <= 3, 1, 0) + XIF(kelg_kolikoredova >= 4, 1, 0) + XIF(kelg_kolikoredova >= 5, 1, 0) + XIF(kelg_kolikoredova >= 6, 1, 0)) * (ROUND(((msirinaunutrasnjaizmedjupregradnih - 270) / 600) + 1, 0));
  // NJ 2025-03-06: Izmeniti formulu na sledecu:
  // =((IF(kelg_kolikoredova<=3; 1; 0) + IF(kelg_kolikoredova>=4; 1; 0) + IF(kelg_kolikoredova>=5; 1; 0) + IF(kelg_kolikoredova>=6; 1; 0))*(ROUND(((msirinaunutrasnjaizmedjupregradnih-270)/600)+1;0)))*(IF(kelg_kolikoredova=3; 2; IF(kelg_kolikoredova=5; 4; IF(kelg_kolikoredova=6; 5; IF(kelg_kolikoredova>=4; 3; "")))))
  kelg_kolicina_p5 = ((XIF(kelg_kolikoredova <= 3, 1, 0) + XIF(kelg_kolikoredova >= 4, 1, 0) + XIF(kelg_kolikoredova >= 5, 1, 0) + XIF(kelg_kolikoredova >= 6, 1, 0)) * (ROUND(((msirinaunutrasnjaizmedjupregradnih - 270) / 600) + 1, 0))) * (XIF(kelg_kolikoredova === 3, 2, XIF(kelg_kolikoredova === 5, 4, XIF(kelg_kolikoredova === 6, 5, XIF(kelg_kolikoredova >= 4, 3, "")))));
  //
  //
  const protobomp_superdata = {
    msirinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjukrilaca,
    kelg_kolikoredova,
    kelg_kolikogrejacapovisini,
    kelg_sirinakucista,
    kelg_rak_termostat,
    kelg_kolicina_p5,
  };

  //
  // 
  // let _arr = [];
  let _protobomp = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$kelg"), protobomp_superdata);
  //
  //
  const _pbnode_dirty_enrich = _derivat_terkk_kucisteelektrogrejaca_pbnode_dirty_enrich; // TODO
  // ----- kreiranje sklopova
  //
  const _sklop_uzor = {
  };
  let _temp_sklop;
  let _temp_pbnode;
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$kelg/SKLOP_KELG',
    naziv: '* SKLOP KELG',
    kolicina: kolicina, //
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'SKLOP_KELG');
  const { created_tempkey: sklop_kelg } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  // ----- dodavanje primitivnih u sklopove
  //
  if (true) {
    //
    if (true) { // 2. odnosi se na deo P1 sklopa.
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$kelg/P1',
        naziv: '? P1',
        identmaterijala: kelg_materijal_lim,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_kelg);
    }
    //
    if (true) { // 3. odnosi se na deo P2 sklopa.
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$kelg/P2',
        naziv: '? P2',
        identmaterijala: kelg_materijal_lim,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_kelg);
    }
    //
    if (true) { // 4. odnosi se na deo P3 sklopa.
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$kelg/P3',
        naziv: '? P3',
        identmaterijala: kelg_materijal_lim,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_kelg);
    }
    //
    if (true) { // 5. odnosi se na deo P4 sklopa.
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$kelg/P4',
        naziv: '? P4',
        identmaterijala: kelg_materijal_lim,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_kelg);
    }
    //
    if (true) { // 6. odnosi se na deo P5 sklopa.
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$kelg/P5',
        naziv: '? P5',
        identmaterijala: kelg_materijal_lim,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_kelg);
    }
    //
    if (true) { // 7. ovaj element se unosi kao materijal:
      const item = {
        // tempkey: 140,
        pbnode_family: 'terkk$kelg/PRITEZAC',
        naziv: "Pritezač elektro grejača",
        kolicina: -1, // Količina: ($Broj_redova*$Broj_grejaca_po_visini)*količina elementa P5
        jm: tclocal.JM_KOM,
        terkategorija: "M",
        identcustom: "ELGP6000000",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_kelg);
    }
    //

  }
  //
  //
  return {
    // _arr,
    _protobomp,
  };
};


// ---------- VIRBOM DERIVATS ----------


export const derAutoCreateVirbom_terkk_kucisteelektrogrejaca_prepare_vir_input = (p) => {
  // TODO
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const v_input = {
    p: p,


  };
  return v_input;
};


export const derAutoCreateVirbom_terkk_kucisteelektrogrejaca_children = (v_input) => {
  console.log('derAutoCreateVirbom_terkk_kucisteelektrogrejaca_children(v_input) ');
  console.log(v_input);

  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};


